module.exports = __webpack_public_path__ + "static/img/empty.ed5350c7.png";